package one.healthium.data.user.storage

import co.touchlab.kermit.Logger
import io.github.xxfast.kstore.KStore
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.filterIsInstance
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch
import one.healthium.Platform
import one.healthium.data.user.utils.createKStore
import one.healthium.domain.user.UserModel
import one.healthium.domain.user.models.UserProfileModel
import kotlin.time.Instant

class LocalUserStorage(
    platform: Platform,
) {

    private val _state = MutableStateFlow<UserHolder>(UserHolder.Uninitialised)

    private val scope = CoroutineScope(Dispatchers.Default + CoroutineExceptionHandler { _, e ->
        Logger.e("LocalUserStorage", e)
    })

    private val store: KStore<UserModel> = createKStore(platform, "user_data_v2")

    init {
        scope.launch {
            try {
                val userModel: UserModel? = store.get()
                _state.emit(UserHolder.Value(userModel))
            } catch (e: Exception) {
                Logger.e("load user error", e)
                _state.emit(UserHolder.Value(null))
            }
        }
        scope.launch {
            _state
                .filterIsInstance<UserHolder.Value>()
                .collect {
                    try {
                        if (it.user == null) {
                            store.delete()
                        } else {
                            store.set(it.user)
                        }
                    } catch (e: Exception) {
                        Logger.e("store user error", e)
                    }
                }
        }
    }

    fun get(): Flow<UserModel?> {
        return _state
            .filterIsInstance<UserHolder.Value>()
            .map { it.user }
    }

    fun set(data: UserModel) {
        _state.update { UserHolder.Value(data) }
    }

    fun updateProfile(data: UserProfileModel) {
        updateUser { user ->
            user.copy(profile = data)
        }
    }

    fun addWaterIntake(value: Float) {
        // TODO
//        updateUser { user ->
//            user.copy(
//                todayWaterLog = user.todayWaterLog?.copy(value = value) ?: WaterLogModel(value)
//            )
//        }
    }

    fun updateWeight(value: Float) {
        // TODO
//        updateUser { user ->
//            user.copy(
//                latestWeightLog = WeightLogModel(value = value, date = Clock.System.now().toEpochMilliseconds())
//            )
//        }
    }

    fun setWeightForDate(date: Instant, value: Float) {
        // TODO
    }

    suspend fun clear() {
        store.delete()
        _state.update { UserHolder.Value(null) }
    }

    private fun updateUser(block: (UserModel) -> UserModel) {
        _state.update { userHolder ->
            when (userHolder) {
                UserHolder.Uninitialised -> {
                    Logger.d("user holder is not initialised, skip user update")
                    userHolder
                }

                is UserHolder.Value -> UserHolder.Value(userHolder.user?.let(block))
            }
        }

    }
}

private sealed class UserHolder {
    data object Uninitialised : UserHolder()
    data class Value(val user: UserModel?) : UserHolder()
}
